

































import Vue from "vue";
import { declension } from "@/services/utils";
import { commonModule } from "@/plugins/store-accessors";
import { cartModule } from "@/plugins/store-accessors";

import ClearBasket from "@/components/organisms/Modal/ClearBasket.vue";

export default Vue.extend({
  name: "TotalSum",
  components: {
    ClearBasket,
  },
  props: {
    sum: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    action: { type: Function, default: () => null },
  },
  data() {
    return {
      showClearModal: false,
    };
  },
  computed: {
    declensed() {
      return declension(this.total, ["товар", "товара", "товаров"]);
    },

    hidePrice() {
      return commonModule.hidePrice;
    },
  },
  methods: {
    clearBasket() {
      return cartModule.removeAllProducts();
    },
  },
});
